import styled from 'styled-components';

/**
 * Groups related sub-sections (e.g. Current + Previous Address) and adds a
 * bottom border after the group.  Use `&:last-child` to suppress the border
 * on the final group (Additional Income).
 */
export const SectionGroup = styled.div`
    border-bottom: ${({ theme }) => `1px solid ${theme.dashboardDrActivityDashboardHrDividerBorderBottom}`};
    padding-top: 1.143rem;
    padding-bottom: 1.143rem;

    &:last-child {
        border-bottom: none;
    }
`;

export const ExpandedSectionCard = styled.div`
    background-color: #f4f4f4;
    padding: 1.143rem;
`;

export const AdditionalIncomeCard = styled.div`
    background-color: #ffffff;
    padding: 1.143rem;
`;

export const LayoutHeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.143rem;
`;
